export const sanitizeSectionKey = (value = '') =>
  String(value)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')

export const buildDefaultSectionKey = (section, index = 0) => {
  const type = section?.type || 'section'
  return `${sanitizeSectionKey(type)}-${index + 1}`
}

export const createUniqueSectionKey = (value, type, sections = [], currentSectionId = null) => {
  const baseValue = sanitizeSectionKey(value) || sanitizeSectionKey(type) || 'section'

  const usedKeys = sections
    .filter((section) => section.id !== currentSectionId)
    .map((section) => section.key)
    .filter(Boolean)

  if (!usedKeys.includes(baseValue)) {
    return baseValue
  }

  let counter = 2
  let nextValue = `${baseValue}-${counter}`

  while (usedKeys.includes(nextValue)) {
    counter += 1
    nextValue = `${baseValue}-${counter}`
  }

  return nextValue
}

export const ensureSectionKey = (section, sections = []) => {
  if (section?.key) return section.key

  const sameTypeSections = sections.filter((item) => item.type === section.type)
  const index = sameTypeSections.findIndex((item) => item.id === section.id)

  return buildDefaultSectionKey(section, index >= 0 ? index : 0)
}

export const getSectionCssSelectors = (section) => {
  const key = section?.key || section?.type || 'section'

  return [
    `.storefront-section--${key}`,
    `.storefront-section--${key} .storefront-section__header`,
    `.storefront-section--${key} .storefront-section__body`,
    `.storefront-section--${key} .section-title`,
  ]
}